<template>
  <div>
    <data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      :fetch="fetch"
      :search="query"
      :server-items-length="
        pagingMetadata.totalCount ? pagingMetadata.totalCount : Infinity
      "
      :reset-search="resetSearch"
      item-key="id"
      :options="options"
      :update-options="updateOptions"
    >
      <template v-slot:item.logo="{ item }">
        <v-img
          v-if="item.logo"
          :src="item.logo"
          :alt="item.name"
          max-width="32"
        />
      </template>
      <template v-slot:item.referent="{ item }">
        <div
          v-if="item.referent.id !== undefined"
          v-html="
            $options.filters.colorTextWrapper(
              `${item.referent.nomComplet}`,
              query
            )
          "
        ></div>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-end">
          <create-button :entity="item">
            <template v-slot:default="{ on, loading }">
              <v-btn class="mr-5" text icon :loading="loading" @click="on">
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
          </create-button>
          <delete-company-button :entities="[item]" />
        </div>
      </template>

      <template v-slot:bulkDelete="{ selectedEntities, onSuccess }">
        <delete-company-button
          :entities="selectedEntities"
          v-slot="{ on, disabled }"
          @success="onSuccess"
        >
          <v-btn v-on="on" :disabled="disabled" text color="primary">{{
            $t("Supprimer")
          }}</v-btn>
        </delete-company-button>
      </template>
    </data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { FETCH, RESET_SEARCH } from "@/store/action-types";
import { mapCompanySearchFormFields } from "@/store/modules/company";
import DataTable from "@/components/functional/DataTable";
import CreateButton from "@/components/companies/CreateButton";
import DeleteCompanyButton from "@/components/companies/DeleteCompanyButton";

const {
  mapActions: mapCompanyActions,
  mapState: mapCompanyState
} = createNamespacedHelpers(`company`);

const { mapActions: mapCompanySearchFormActions } = createNamespacedHelpers(
  `company/searchForm`
);

export default {
  components: {
    DataTable,
    CreateButton,
    DeleteCompanyButton
  },
  data() {
    return {
      selected: [],
      headers: [
        { text: "Logo", value: "logo", sortable: false },
        { text: "Société", value: "nomComplet" },
        { text: "Référent", value: "referent" },
        { text: "", value: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapCompanyState(["list", "pagingMetadata"]),
    ...mapCompanyState({
      entityLoading: "loading"
    }),
    ...mapCompanySearchFormFields(["query", "options"]),
    ...mapCompanySearchFormFields({
      entitySearchLoading: "loading"
    }),
    loading() {
      return this.entityLoading || this.entitySearchLoading;
    }
  },
  methods: {
    ...mapCompanyActions({
      fetch: FETCH
    }),
    ...mapCompanySearchFormActions({
      resetSearch: RESET_SEARCH
    }),
    updateOptions(newOptions) {
      this.options = newOptions;
    }
  }
};
</script>
